import React from "react";
import { useTranslation } from "react-i18next";
import { Container } from "react-bootstrap";
import blackPipe from "../Assets/img/blackPipe.png";
import sanaPanel from "../Assets/img/sanaPanel.png";
import powerPanel from "../Assets/img/powerPanel.png";
import qb from "../Assets/img/qb.png";
import brc from "../Assets/img/qandelbrc.png";
import smood from "../Assets/img/alsmood.png";
import raw from "../Assets/img/rawsteel.png";

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <div id="footer">
      <Container
        fluid
        className="footer d-flex justify-content-between align-items-center"
      >
        <div>
          <span className="copyright ">{t("copy_right")}</span>
        </div>
        <div>
          <div>
            <ul className="list-unstyled m-0">
              <li className="d-inline mx-1 mx-lg-3">
                <img
                  src={qb}
                  className="img-fluid footerbrand"
                  alt="power panel"
                />
              </li>
              <li className="d-inline mx-1 mx-lg-3">
                <img
                  src={brc}
                  className="img-fluid footerbrand"
                  alt="qandel brc"
                />
              </li>
              <li className="d-inline mx-1 mx-lg-3">
                <img
                  src={blackPipe}
                  className="img-fluid footerbrand"
                  alt="black pipe"
                />
              </li>
              <li className="d-inline mx-1 mx-lg-3">
                <img
                  src={smood}
                  className="img-fluid footerbrand"
                  alt="al smood"
                />
              </li>
              <li className="d-inline mx-1 mx-lg-3">
                <img
                  src={powerPanel}
                  className="img-fluid footerbrand"
                  alt="power panel"
                />
              </li>
              <li className="d-inline mx-1 mx-lg-3">
                <img
                  src={sanaPanel}
                  className="img-fluid footerbrand"
                  alt="sana panel"
                />
              </li>
              <li className="d-inline mx-1 mx-lg-3">
                <img
                  src={raw}
                  className="img-fluid footerbrand"
                  alt="raw steel"
                />
              </li>
            </ul>
          </div>
        </div>
      </Container>
    </div>
  );
};
